import { CALL_LABEL_HINT, CALL_LABEL_TEXT, type CallLabel } from "@shared/call-summary";
import type { CallSummaryView } from "@shared/webinar-api";
import { cn } from "@/lib/utils";

const LABEL_STYLE: Record<CallLabel, string> = {
  chaud: "bg-red-100 text-red-700",
  timing: "bg-amber-100 text-amber-800",
  argent: "bg-blue-100 text-blue-800",
  froid: "bg-zinc-200 text-zinc-700",
};

const SOURCE_TEXT = { fireflies: "Fireflies", fathom: "Fathom" } as const;

/** Étiquette + phrase + lien vers l'enregistrement du dernier appel (null : rien). */
export function CallSummaryBadge({
  summary,
  variant,
}: {
  summary: CallSummaryView | null;
  variant: "row" | "brief";
}) {
  if (!summary) return null;
  const row = variant === "row";
  const canLink = summary.recordingUrl.startsWith("https://");
  return (
    <span
      className={cn(
        "flex min-w-0 gap-x-2 gap-y-0.5",
        row ? "flex-wrap items-center" : "flex-col items-start",
      )}
    >
      <span className="inline-flex items-center gap-2">
        <span
          title={CALL_LABEL_HINT[summary.label]}
          className={cn(
            "inline-block shrink-0 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold",
            LABEL_STYLE[summary.label],
          )}
        >
          {CALL_LABEL_TEXT[summary.label]}
        </span>
        {!row && (
          <span className="text-xs text-[var(--color-muted-foreground)]">
            {SOURCE_TEXT[summary.source]}
          </span>
        )}
      </span>
      <span
        className={cn(
          "min-w-0 text-[var(--color-foreground)]",
          row ? "text-xs max-sm:basis-full sm:flex-1 sm:truncate" : "text-sm leading-snug",
        )}
      >
        {summary.phrase}
      </span>
      {canLink && (
        <a
          href={summary.recordingUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className={cn(
            "shrink-0 text-xs text-blue-600 underline hover:text-blue-800",
            row && "max-sm:-my-3 max-sm:inline-flex max-sm:min-h-11 max-sm:items-center",
          )}
        >
          Écouter sur {SOURCE_TEXT[summary.source]} ↗
        </a>
      )}
    </span>
  );
}
